import React from 'react';
import './ImageGrid.css';

const ImageGrid = () => {
  const images = [
    '/intropics/courtreservation.png',
    '/intropics/tournamentplanner.png',
    '/intropics/membershipManagement.png',
    '/intropics/Dashboards.png',
    '/intropics/Notifications.png',
    '/intropics/curriculumTracker.png',
    '/intropics/inventoryManagement.png'
  ];

  return (
    <div className="image-container">
      <div className="spinner"></div>
      {images.map((src, index) => (
        <img key={index} src={src} alt={`Image ${index + 1}`} className={`image img-${index + 1}`} />
      ))}
    </div>
  );
};

export default ImageGrid;